var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTheater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2.4 0.13 58.4 58.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mk",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbe55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e57a0c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(31 8) rotate(12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2 Q15 -5 30 2 Q32 22 23 33 Q15 41 7 33 Q-2 22 0 2Z",
    fill: "url(#mk)",
    stroke: "#a65508",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5c2600"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 9 Q8.5 16 13 10 Q8.5 12 4 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 10 Q21.5 16 26 9 Q21.5 12 17 10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 27 Q15 14 24 27 Q15 22 6 27Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 14) rotate(-8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2 Q15 -5 30 2 Q32 22 23 33 Q15 41 7 33 Q-2 22 0 2Z",
    fill: "url(#mk)",
    stroke: "#a65508",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5c2600"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 13 Q8.5 5 13 13 Q8.5 10 4 13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 13 Q21.5 5 26 13 Q21.5 10 17 13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 19 Q15 36 26 19 Q15 25 4 19Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheater);
export default __webpack_public_path__ + "static/media/theater.122a0b688b21f321b37c4386f12f1702.svg";
export { ForwardRef as ReactComponent };